import { render, staticRenderFns } from "./TabProductImage.vue?vue&type=template&id=69bcc248&scoped=true"
import script from "./TabProductImage.vue?vue&type=script&lang=js"
export * from "./TabProductImage.vue?vue&type=script&lang=js"
import style0 from "./TabProductImage.vue?vue&type=style&index=0&id=69bcc248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bcc248",
  null
  
)

export default component.exports